import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header_main" }
const _hoisted_2 = { class: "header_logo" }
const _hoisted_3 = {
  key: 0,
  src: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933680089/logo_blank.png"
}
const _hoisted_4 = {
  key: 1,
  src: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933747160/logo_white.png",
  alt: ""
}
const _hoisted_5 = { class: "header_tab" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", _ctx.scrollTop > _ctx.scrollNum ? 'header_bg' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.scrollTop > _ctx.scrollNum)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tab_item", _ctx.tabIndex == index ? 'tab_item_active' : '']),
            onClick: ($event: any) => (_ctx.handleOpen(item)),
            key: index
          }, [
            _createVNode(_component_router_link, {
              to: item.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 10, _hoisted_6))
        }), 128))
      ])
    ])
  ], 2))
}